import Header from "../components/Header";
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import HowItWorks from "../components/HowItWorks";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div
      data-testid="landing-page"
      className="min-h-screen"
      style={{ background: "var(--fp-cream)" }}
    >
      <Header />
      <main>
        <Hero />
        <Benefits />
        <HowItWorks />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
